// extracted by mini-css-extract-plugin
export default {"wrapper":"MinerLocation_wrapper__7W0NK","link":"MinerLocation_link__DfLUz"};